// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventRegistrationEntity from './entities/event-registration.json';
import eventRegistrationMenu from '../pages/event-registration/menu.json';
import eventRegistrationFullForm from '../pages/event-registration/forms/full.json';
import eventRegistrationContextForm from '../pages/event-registration/forms/context.json';
import eventRegistrationMiniForm from '../pages/event-registration/forms/mini.json';
import eventRegistrationLookupForm from '../pages/event-registration/forms/lookup.json';
import eventRegistrationTableView from '../pages/event-registration/views/table.json';
import eventRegistrationCardsView from '../pages/event-registration/views/cards.json';
import eventRegistrationDashboardView from '../pages/event-registration/views/dashboard.json';

/** Тип запису «Реєстрація» зі сторінками пакета: меню, форми та подання з pages/event-registration/. */
export const eventRegistrationDefinition: IRecordTypeDefinition = {
  ...eventRegistrationEntity,
  views: assembleViewSet({
      table: eventRegistrationTableView,
      cards: eventRegistrationCardsView,
      dashboard: eventRegistrationDashboardView,
  }),
  form: eventRegistrationFullForm,
  forms: { full: eventRegistrationFullForm, context: eventRegistrationContextForm, mini: eventRegistrationMiniForm, lookup: eventRegistrationLookupForm },
  menu: eventRegistrationMenu,
} as IRecordTypeDefinition;
